import { CSSProperties } from "react"

export type SectionBase = {
  background: "none" | "muted" | "accent"
  paddingY: "none" | "sm" | "md" | "lg"
}

export const sectionBackgrounds: Record<SectionBase["background"], CSSProperties> = {
  none: { background: "transparent" },
  muted: { background: "var(--site-bg-muted, #f6f6f7)" },
  accent: { background: "var(--site-bg-accent, #111827)", color: "#fff" },
}

export const sectionPaddings: Record<SectionBase["paddingY"], CSSProperties> = {
  none: { paddingTop: 0, paddingBottom: 0 },
  sm: { paddingTop: 32, paddingBottom: 32 },
  md: { paddingTop: 64, paddingBottom: 64 },
  lg: { paddingTop: 96, paddingBottom: 96 },
}

export function sectionStyle(base: SectionBase): CSSProperties {
  return { ...sectionBackgrounds[base.background], ...sectionPaddings[base.paddingY] }
}
